<template>
  <b-container fluid>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      :is-form-valid="isFormValid"
      tool-name="Paywall Configuration (Deprecated)"
      :config-name="configName"
      :can-edit="canPaywallEdit"
      :can-publish="canPaywallPublish">
      <template slot="header">
        <b-col class="pr-0">
          <b-form-radio-group
            v-model="configName"
            class="float-right"
            buttons
            button-variant="outline-primary">
            <b-form-radio value="paywall_en">
              EN
            </b-form-radio>
            <b-form-radio value="paywall_es">
              ES
            </b-form-radio>
          </b-form-radio-group>
        </b-col>
      </template>
    </config-publisher>
    <b-container
      class="d-flex flex-column pl-5 pr-5 mb-3"
      fluid>
      <paywall-menu
        v-if="config"
        ref="paywallform"
        class="mt-3"
        :config="config" />
    </b-container>
  </b-container>
</template>

<script>
import ConfigPublisher from "@/components/ConfigPublisher"
import PaywallMenu from "@/components/Paywall/PaywallMenu"
import {mapGetters} from "vuex"

export default {
  name: "Paywall",
  components: {
    PaywallMenu,
    ConfigPublisher,
  },
  data: () => ({
    config: {},
    configName: "paywall_en",
  }),
  computed: {
    ...mapGetters(["betaEnvName", "liveEnvName", "canPaywallEdit", "canPaywallPublish"]),
  },
  methods: {
    isFormValid: function () {
      return this.$refs.paywallform.isValid()
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.configPublisher.configHasChanged()) {
      const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
      next(await this.$confirm.open(message))
    } else {
      next()
    }
  },
}
</script>

<style scoped></style>
